(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[774],{

/***/ 10774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content010": function() { return /* binding */ Content010; },
  "default": function() { return /* binding */ Content010_Content010; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./src/shared/components/Tabs/Tabs.Provider.js
var Tabs_Provider = __webpack_require__(11742);
// EXTERNAL MODULE: ./src/components/widgets/content/Content010/Content010.module.scss
var Content010_module = __webpack_require__(83828);
var Content010_module_default = /*#__PURE__*/__webpack_require__.n(Content010_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content010/Content010.utils.js
var serializeItem = function(item) {
    return item.yearFrom + "-" + item.yearTo;
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/RichTextWidget/index.js + 11 modules
var RichTextWidget = __webpack_require__(14258);
// EXTERNAL MODULE: ./src/shared/components/Tabs/Tabs.hooks.js
var Tabs_hooks = __webpack_require__(60419);
// EXTERNAL MODULE: ./src/components/widgets/content/Content010/YearsView/YearsView.module.scss
var YearsView_module = __webpack_require__(76076);
var YearsView_module_default = /*#__PURE__*/__webpack_require__.n(YearsView_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content010/YearsView/YearsView.jsx








var YearsView = function(param) {
    var items = param.items;
    var activeTab = (0,Tabs_hooks/* useTabsState */.n)().activeTab;
    var filteredYears = (0,react.useMemo)(function() {
        return items.filter(function(item) {
            return serializeItem(item) === activeTab;
        });
    }, [
        activeTab,
        items
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: filteredYears.map(function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((YearsView_module_default()).years, (0,_define_property/* default */.Z)({}, (YearsView_module_default())["fade-in"], serializeItem(item) === activeTab)),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: item.yearFrom
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: item.yearTo
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((YearsView_module_default()).description, (0,_define_property/* default */.Z)({}, (YearsView_module_default())["fade-in"], serializeItem(item) === activeTab)),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget/* RichText */.H, {
                            value: item.description
                        })
                    })
                ]
            }, item.id);
        })
    });
};
/* harmony default export */ var YearsView_YearsView = (YearsView);

;// CONCATENATED MODULE: ./src/components/widgets/content/Content010/Content010.jsx







var Content010 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var historyPeriods = (0,react.useMemo)(function() {
        return (ref1 = payload === null || payload === void 0 ? void 0 : payload.historyPeriods) !== null && ref1 !== void 0 ? ref1 : [];
    }, [
        payload
    ]);
    var extractedTabYears = historyPeriods.map(function(item) {
        return serializeItem(item);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Content010_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* Container */.W2, {
            className: (Content010_module_default()).inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Content010_module_default()).header,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading2 */.XJ, {
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs_Provider/* TabsProvider */.X, {
                    items: extractedTabYears,
                    tabsEnabled: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Content010_module_default()).blocks,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Content010_module_default()).tabs,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Tabs */.mQ, {
                                    tabType: "tab-years"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(YearsView_YearsView, {
                                items: historyPeriods
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Content010_Content010 = (Content010);


/***/ }),

/***/ 83828:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content010_wrapper__OyuYQ","header":"Content010_header__0HtDm","blocks":"Content010_blocks__SsdqO","tabs":"Content010_tabs__TYqee"};

/***/ }),

/***/ 76076:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"years":"YearsView_years__pCl5l","fade-in":"YearsView_fade-in__sRsDF","fadeIn":"YearsView_fadeIn__L2zaX","description":"YearsView_description__dFg0_"};

/***/ })

}]);